import React, { useEffect } from "react";
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    TextField,
    Grid,
    FormGroup,
    Typography,
    Switch,
    FormControl,
    InputLabel,
    Select,
    Input,
    MenuItem,
    FormHelperText,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Autocomplete } from '@mui/material';


import { Formik } from "formik";
import { Loadable } from "../../../../common";


const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(1)
    },
    textField: {
        width: "100%"
    },
    root: {
        flexGrow: 1
    },
    autoComplete: {
        position: "relative",
        top: "16px"
    },
    toggle:{
        marginTop:'10px',
        marginBottom:'10px'
    },
    formControlDropdown: {
        marginTop: theme.spacing(2),
        width: '100%',
    },
}));

export default function ChargeMasterDialog({
    open,
    handleRefresh,
    mode,
    intl,
    initialValues,
    drugMeasurementTypes,
    facilities,
    chargeMasterCreatePending,
    chargeMasterUpdatePending,
    getFacilitiesPending,
    actions: {
        chargeMasterCreate,
        chargeMasterUpdate,
        setChargeMasterEditDialog,
        getFacilities
    }
}) {
    
    const classes = useStyles();

    useEffect(() => {
        getFacilities();
    }, [getFacilities]);

    function handleClose() {
        setChargeMasterEditDialog(null);

    }

    function handleCallback() {
        handleClose();
        handleRefresh();
    }

    const resetNdcValues = (setFieldValue) => {     
        setFieldValue('ndc','')
        setFieldValue('drugTypeOfMeasurement',null)
        setFieldValue('drugUnitOfMeasurement','') 
}

    const handleStatusToggle = (e,setFieldValue) => {
        setFieldValue('showNdc',e.target.checked)
        if(e.target.checked===false)
        {
            resetNdcValues(setFieldValue)
        
        }
    }

    


    return (
        (<Dialog
                fullWidth
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
            <DialogTitle id="form-dialog-title">
                {mode === "edit"
                    ? "Edit Charge Master Item"
                    : "Add Charge Master Item"}
            </DialogTitle>
            <DialogContent dividers>
                <Loadable
                    loading={
                        chargeMasterCreatePending || chargeMasterUpdatePending || getFacilitiesPending
                    }
                >
                    <Formik
                        enableReinitialize={true}
                        initialValues={initialValues}
                        validate={values => {
                            const errors : any = {};

                            if (mode === 'create' && !values.facilityName) {
                                errors.facilityName = intl.formatMessage({
                                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                });
                            }

                            if (!values.code) {
                                errors.code = intl.formatMessage({
                                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                });
                            }

                            if (!values.description) {
                                errors.description = intl.formatMessage({
                                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                });
                            }

                            if (!values.amount && values.amount !== 0) {
                                errors.amount = intl.formatMessage({
                                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                });
                            } else if (parseFloat(values.amount) < 0) {
                                errors.amount = "Charge Amount cannot be negative.";
                            }

                            if (!values.revenueCode && !values.cpT_HCPCS) {
                                errors.revenueCode =
                                    "Either CPT or Rev Code is required";
                            }
                            const isDrugFieldFilled =
                                values.drugTypeOfMeasurement ||
                                values.drugUnitOfMeasurement ||
                                values.ndc;
                            if (isDrugFieldFilled) {
                                if (!values.drugTypeOfMeasurement && values.drugUnitOfMeasurement) {
                                    errors.drugTypeOfMeasurement = intl.formatMessage(
                                        {
                                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                    }
                                );
                                }
                                if (!values.drugUnitOfMeasurement && values.drugTypeOfMeasurement) {
                                    errors.drugUnitOfMeasurement = intl.formatMessage(
                                        {
                                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                    }
                                );
                                }
                                if (values.ndc) {
                                    if (!values.drugTypeOfMeasurement) {
                                        errors.drugTypeOfMeasurement = intl.formatMessage(
                                            {
                                                id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                            }
                                        );                                                                                                          
                                    }
                                    if (!values.drugUnitOfMeasurement) {
                                        errors.drugUnitOfMeasurement = intl.formatMessage(
                                            {
                                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                        }
                                    );
                                    }
                                }
                                if (values.drugTypeOfMeasurement && values.drugUnitOfMeasurement && !values.ndc) {
                                    errors.ndc = intl.formatMessage({
                                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                    });
                                }
                            }

                            const mods = [
                                { key: 'mod1', val: values.mod1 },
                                { key: 'mod2', val: values.mod2 },
                                { key: 'mod3', val: values.mod3 },
                                { key: 'mod4', val: values.mod4 },
                            ].filter(m => m.val && m.val.trim());
                            const modValues = mods.map(m => m.val.trim().toLowerCase());
                            if (modValues.length !== new Set(modValues).size) {
                                const dupMsg = "Modifiers must be unique.";
                                mods.forEach(m => {
                                    if (modValues.filter(v => v === m.val.trim().toLowerCase()).length > 1)
                                        errors[m.key] = dupMsg;
                                });
                            }

                            if (values.ndc.length>15) {
                                errors.ndc = "NDC should not exceed 15 characters.";

                            }
                            if(String(values.drugUnitOfMeasurement).length>10)
                            {
                                errors.drugUnitOfMeasurement = "Drug Unit of Measurement should not be Greater than 10 Digits.";

                            }
    

                            return errors;
                        }}
                        onSubmit={(values, { setStatus, setSubmitting }) => {
                            let payload = {
                                id: undefined,
                                code: values.code?.trim(),
                                departmentName: values.departmentName?.trim(),
                                description: values.description?.trim(),
                                gl: values.gl?.trim(),
                                amount: values.amount,
                                revenueCode: values.revenueCode?.trim(),
                                cpT_HCPCS: values.cpT_HCPCS?.trim(),
                                mod1: values.mod1?.trim(),
                                mod2: values.mod2?.trim(),
                                mod3: values.mod3?.trim(),
                                mod4: values.mod4?.trim(),
                                ndc: values?.ndc?.trim(),
                                drugTypeOfMeasurement:
                                    values?.drugTypeOfMeasurement,
                                drugUnitOfMeasurement:
                                    values?.drugUnitOfMeasurement,
                                facilityName: values?.facilityName?.trim()
                            };
                            if (mode === "create") {
                                chargeMasterCreate(payload, handleCallback);
                            } else {
                                payload = {
                                    ...payload,
                                    id: values.id
                                };
                                chargeMasterUpdate(
                                    values.id,
                                    payload,
                                    handleCallback
                                );
                            }
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue
                        }) => (
                            <form
                                onSubmit={handleSubmit}
                                noValidate
                                autoComplete="off"
                            >
                                <div className={classes.root}>
                                    <Grid
                                        container
                                        spacing={3}
                                        className="px-2"
                                    >
                                        <Grid item xs={12} md={6} >
                                            <FormControl className={classes.formControlDropdown}>
                                                <InputLabel htmlFor="contractStateId">Facility</InputLabel>
                                                <Select
                                                required
                                                disabled={mode === "edit" ? true : false}
                                                value={values.facilityName}
                                                onChange={handleChange}
                                                error={Boolean(touched.facilityName && errors.facilityName)}
                                                input={<Input id="facilityName" />}
                                                inputProps={{
                                                    name: "facilityName",
                                                    id: "facilityName"
                                                }}
                                                >
                                                {facilities.map(facility => (
                                                    <MenuItem
                                                    key={facility.name}
                                                    value={facility.name}
                                                    >
                                                    {facility.name}
                                                    </MenuItem>
                                                ))}
                                                </Select>
                                                <FormHelperText error>{touched.facilityName && errors.facilityName}</FormHelperText>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                required
                                                label="Code"
                                                name="code"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.code}
                                                helperText={
                                                    touched.code && errors.code
                                                }
                                                error={Boolean(
                                                    touched.code && errors.code
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Department"
                                                name="departmentName"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.departmentName}
                                                helperText={
                                                    touched.departmentName &&
                                                    errors.departmentName
                                                }
                                                error={Boolean(
                                                    touched.departmentName &&
                                                        errors.departmentName
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                required
                                                label="Description"
                                                name="description"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.description}
                                                helperText={
                                                    touched.description &&
                                                    errors.description
                                                }
                                                error={Boolean(
                                                    touched.description &&
                                                        errors.description
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="GL"
                                                name="gl"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.gl}
                                                helperText={
                                                    touched.gl && errors.gl
                                                }
                                                error={Boolean(
                                                    touched.gl && errors.gl
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                type="number"
                                                required
                                                label="Amount"
                                                name="amount"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.amount}
                                                helperText={
                                                    touched.amount &&
                                                    errors.amount
                                                }
                                                error={Boolean(
                                                    touched.amount &&
                                                        errors.amount
                                                )}
                                            />
                                        </Grid>

                                       
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                required={values.cpT_HCPCS.length === 0}
                                                label="Revenue Code"
                                                name="revenueCode"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.revenueCode}
                                                error={Boolean(
                                                    touched.revenueCode &&
                                                        errors.revenueCode
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                required={values.revenueCode.length === 0}
                                                label="CPT/HCPCS"
                                                name="cpT_HCPCS"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.cpT_HCPCS}
                                                helperText={
                                                    touched.revenueCode &&
                                                    errors.revenueCode
                                                }
                                                error={Boolean(
                                                    touched.revenueCode &&
                                                        errors.revenueCode
                                                )}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Mod 1"
                                                name="mod1"
                                                inputProps={{ maxLength: 2 }}
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.mod1}
                                                error={Boolean(
                                                    touched.mod1 && errors.mod1
                                                )}
                                                helperText={touched.mod1 && errors.mod1}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Mod 2"
                                                name="mod2"
                                                inputProps={{ maxLength: 2 }}
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.mod2}
                                                error={Boolean(
                                                    touched.mod2 && errors.mod2
                                                )}
                                                helperText={touched.mod2 && errors.mod2}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Mod 3"
                                                name="mod3"
                                                inputProps={{ maxLength: 2 }}

                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.mod3}
                                                error={Boolean(
                                                    touched.mod3 && errors.mod3
                                                )}
                                                helperText={touched.mod3 && errors.mod3}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Mod 4"
                                                name="mod4"
                                                inputProps={{ maxLength: 2 }}
                                                
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.mod4}
                                                error={Boolean(
                                                    touched.mod4 && errors.mod4
                                                )}
                                                helperText={touched.mod4 && errors.mod4}
                                            />
                                        </Grid>


                                        <Grid item xs={12} md={6}>
                                            <Autocomplete
                                                className={classes.autoComplete}
                                                onChange={(event, newValue) => {
                                                    setFieldValue("drugTypeOfMeasurement", newValue);
                                                }}
                                                value={values.drugTypeOfMeasurement || null}
                                                // name="drugTypeOfMeasurement"
                                                options={drugMeasurementTypes}
                                                getOptionLabel={(option) => option || ''}
                                                // getOptionSelected={(option, value) => option === value}
                                                isOptionEqualToValue={(option, value) => option === value}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="drugTypeOfMeasurement"
                                                        label="Drug Type Of Measurement"
                                                        error={Boolean(touched.drugTypeOfMeasurement && errors.drugTypeOfMeasurement)}
                                                        helperText={touched.drugTypeOfMeasurement && errors.drugTypeOfMeasurement}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                type="number"
                                                label="Drug Unit of Measurement"
                                                name="drugUnitOfMeasurement"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={
                                                    values.drugUnitOfMeasurement
                                                }
                                                error={Boolean(
                                                    touched.drugUnitOfMeasurement &&
                                                        errors.drugUnitOfMeasurement
                                                )}
                                                helperText={
                                                    touched.drugUnitOfMeasurement &&
                                                    errors.drugUnitOfMeasurement
                                                }
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="NDC"
                                                name="ndc"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.ndc}
                                                error={Boolean(
                                                    touched.ndc && errors.ndc
                                                )}
                                                helperText={
                                                    touched.ndc && errors.ndc
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                    <hr />
                                    <Grid container justifyContent="flex-end">
                                        <Button onClick={handleClose} variant="contained" className={classes.button}>
                                            Cancel
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            className={`ml-3 ${classes.button}`}
                                            type="submit"
                                            disabled={
                                                chargeMasterCreatePending ||
                                                chargeMasterUpdatePending
                                            }
                                        >
                                            {chargeMasterCreatePending ||
                                            chargeMasterUpdatePending
                                                ? "Saving"
                                                : "Save"}
                                        </Button>
                                    </Grid>
                                </div>
                            </form>
                        )}
                    </Formik>
                </Loadable>
            </DialogContent>
        </Dialog>)
    );
}
